module.exports = __webpack_public_path__ + "img/showmorw04.e7e5f10.png";